class CollectionSort {
  constructor() {
    this.init();
  }

  init() {
    if (!window.location.search.includes("sort_by=")) return;

    const urlParams = new URLSearchParams(window.location.search);
    const sortByParam = urlParams.get("sort_by");
    if (!sortByParam) return;

    const productHandles = sortByParam
      .split(",")
      .map((handle) => handle.trim());
    if (productHandles.length === 0) return;

    this.reorderProducts(productHandles);
  }

  reorderProducts(productHandles) {
    const productList = document.querySelector(".product-list--collection");
    if (!productList) return;

    const products = Array.from(productList.children);
    const productMap = new Map();

    // Create a map of products by their handle
    products.forEach((product) => {
      const link = product.querySelector('a[href*="/products/"]');
      if (link) {
        const handle = link
          .getAttribute("href")
          .split("/products/")[1]
          .split("?")[0];
        productMap.set(handle, product);
      }
    });

    // Remove all products
    products.forEach((product) => product.remove());

    // Add featured products first
    productHandles.forEach((handle) => {
      const product = productMap.get(handle);
      if (product) {
        productList.appendChild(product);
        productMap.delete(handle);
      }
    });

    // Add remaining products
    productMap.forEach((product) => {
      productList.appendChild(product);
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new CollectionSort();
});
